module.exports = __webpack_public_path__ + "static/media/redeem.c70383a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/redeem.png
// module id = 90
// module chunks = 0